import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { VStack, Center, Text } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
const ComponentPlacementFC = ({ onClick }) => {
    const { t } = useT();
    return (_jsx(Center, { w: "100%", h: "280px", border: "1px solid", borderRadius: "4px", borderColor: "border", cursor: "pointer", onClick: onClick, children: _jsxs(VStack, { gap: '4px', children: [_jsx(Text, { children: t('DialogableContainer.placementTitle') }), _jsx(Text, { textStyle: "secondary", fontSize: "12px", children: t('DialogableContainer.clickToCollapse') })] }) }));
};
export const ComponentPlacement = memo(ComponentPlacementFC);
//# sourceMappingURL=ComponentPlacement.js.map